import { Cell, flexRender } from '@tanstack/react-table';
import { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledTd = styled.td<{
	$width?: number;
	$minWidth?: number;
	$maxWidth?: number;
}>`
	padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.xs}`};
	${({ $minWidth }) => $minWidth && `min-width: ${$minWidth}px;`}
	${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}px;`}
	${({ $width }) => $width && `width: ${$width}px;`}
`;

const StyledLink = styled(Link)`
	display: block;
	padding: ${({ theme }) => `${theme.spacing.xxs} ${theme.spacing.xs}`};
	color: inherit;
	text-decoration: none;
`;

const Td: FunctionComponent<{
	cell?: Cell<any, any>;
	className?: string;
	children?: ReactNode;
	colSpan?: number;
	width?: number;
	minWidth?: number;
	maxWidth?: number;
	href?: string;
}> = ({
	cell,
	className,
	children,
	colSpan = 1,
	width,
	minWidth,
	maxWidth,
	href,
}) => (
	<StyledTd
		colSpan={colSpan}
		className={className}
		$width={width}
		$maxWidth={maxWidth}
		$minWidth={minWidth}
		style={href ? { padding: 0 } : undefined}
	>
		{href ? (
			<StyledLink to={href}>
				{cell &&
					flexRender(cell.column.columnDef.cell, cell.getContext())}
				{children}
			</StyledLink>
		) : (
			<>
				{cell &&
					flexRender(cell.column.columnDef.cell, cell.getContext())}
				{children}
			</>
		)}
	</StyledTd>
);

export default Td;
